module.exports = __webpack_public_path__ + "img/110x72_top_logo@2x.a1a73a51.png";